/**
 * When a held turn's model is expected to answer, in the server's own estimate
 * (`expectedReadyAt`). A turn without one says so rather than showing a bare "Waiting".
 */
export function expectedReadyLine(expectedReadyAt: Date | string | null | undefined, now: number): string {
  const at = typeof expectedReadyAt === 'string' ? new Date(expectedReadyAt) : expectedReadyAt;
  if (!at || Number.isNaN(at.getTime())) return 'No ready time given';
  const minutes = Math.ceil((at.getTime() - now) / 60000);
  const clock = at.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' });
  return minutes > 0 ? `Expected ready at ${clock} · about ${minutes} min` : `Expected ready at ${clock} · any moment now`;
}
